class ProductMonogrammingLocation extends window.BAO.CustomElement() {  
  connectedCallback () {
    super.connectedCallback()

    this.setupSlider = this.setupSlider.bind(this)

    this.setupSlider()
  }

  setupListeners () {
    super.setupListeners()

    this.handleLocationChange = this.handleLocationChange.bind(this)

    this.els.input.elements.forEach(el => {
      this.listeners.add(el, 'change', this.handleLocationChange)
    })

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PERSONALISATION.RESET,
      this.reset.bind(this),
    )
  }

  handleLocationChange (e) {
    const { target } = e

    // Update form titles
    const title = `${target.value}`
    this.externalEls[`item-${this.index}-title`].elements.forEach(el => {
      el.innerText = title
    })

    // Disable this position for second monogram form
    const altIndex = this.index === 1 ? 2 : 1
    if (this.externalEls[`item-${altIndex}-input`]) {
      this.externalEls[`item-${altIndex}-input`].elements.forEach(el => {
        el.disabled = el.value === target.value
      })
    }

    this.setCharacterCount(target.dataset.maxLength)

    this.toggleButton(true)
  }
  
  setCharacterCount (characterCount) {
    const textInput = this.externalEls[`item-${this.index}-text-input`]?.element

    if (textInput) {
      textInput.maxLength = characterCount

      window.setTimeout(() => {
        textInput.dispatchEvent(new Event('change'))
      }, 1)
    }

    this.externalEls[`item-${this.index}-max-character-count`].elements.forEach(el => {
      el.innerText = characterCount
    })
  }

  toggleButton (enabled) {
    const nextButton = this.els.next.element

    nextButton.disabled = !enabled
    nextButton.innerText = enabled ? nextButton.dataset.activeText : nextButton.dataset.inactiveText
  }

  reset () {
    // Reset location options
    this.els.input.elements.forEach(input => {
      input.checked = false
      input.disabled = false
    })

    // Reset location titles
    this.externalEls[`item-${this.index}-title`].elements.forEach(el => {
      el.innerText = el.dataset.emptyText || ''
    })
    
    // Reset button
    this.toggleButton(false)
  }

  duplicate () {
    const targetIndex = this.index === 1 ? 2 : 1
    const target = document.querySelector(`product-monogramming-location[data-index="${targetIndex}"]`)
    const selected = target.els.input.elements.find(el => el.checked)
    
    // Reset location options
    this.els.input.elements.forEach(input => {
      input.disabled = false

      if (input.value !== selected.value) return

      input.checked = true
      input.dispatchEvent(new Event('change'))
    })
  }

  setupSlider () {
    this.keenSliderInstance = new KeenSlider(this.els.slider.element, {
      selector: this.els.slide.selector,
      loop: false,
      rubberband: false,
      mode: 'snap',
      slides: {
        perView: 1.2,
        spacing: 10,
      },
    }, [
      window.BAO.Carousel.plugins.useInitialised(),
    ])
  }

  get index() {
    return parseInt(this.dataset.index)
  }
}

if (!customElements.get('product-monogramming-location')) {
  customElements.define('product-monogramming-location', ProductMonogrammingLocation)
}
